import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material'
import { useCallback, useState } from 'react'
import { ConfirmationDialog } from 'src/components/ConfirmationDialog'

interface Props {
  phoneNumber: string
  memberId: number
}

import { LockOpen } from '@mui/icons-material'

import { useCreateVerificationCodeOverride } from './useCreateVerificationCodeOverride'

export const OverrideVerificationCode: React.FC<Props> = ({ phoneNumber, memberId }) => {
  const [dialogOpen, setDialogOpen] = useState(false)
  const [confirmationOpen, setConfirmationOpen] = useState(false)
  const [pendingCode, setPendingCode] = useState<string>('')

  const { createVerificationCodeOverride, loading } = useCreateVerificationCodeOverride()

  const handleClose = () => setDialogOpen(false)
  const handleOpen = () => {
    setPendingCode(Math.floor(1000 + Math.random() * 9000).toString())
    setDialogOpen(true)
  }

  const confirmOverride = useCallback(
    async (confirmed: boolean) => {
      setConfirmationOpen(false)
      if (!confirmed) return

        await createVerificationCodeOverride({
          phoneNumber,
          memberId,
          code: pendingCode,
        })
        handleClose()
    },
    [createVerificationCodeOverride, pendingCode, phoneNumber, memberId],
  )

  return (
    <>
      <Button
        startIcon={<LockOpen />}
        size="small"
        variant="contained"
        color="secondary"
        onClick={handleOpen}>
        Override Verification Code
      </Button>
      <Dialog open={dialogOpen} onClose={handleClose} maxWidth="xs" fullWidth>
        <DialogTitle>Override Verification Code</DialogTitle>
        <DialogContent>
          <Typography variant="body2">
            You are about to set an override verification code.
            Please confirm that you have verified the identity of the person receiving this code and that they are the owner of this account.
            Would you like to continue?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="secondary"
            disabled={!phoneNumber || loading}
            onClick={() => setConfirmationOpen(true)}>
            Continue
          </Button>
        </DialogActions>
      </Dialog>
      <ConfirmationDialog
        disabled={loading}
        title="Set Override Code"
        message={`When you confirm, the phone number: ${phoneNumber ?? 'undefined'} will be able to use the override code ${pendingCode} for the next 5 minutes.`}
        open={confirmationOpen}
        onClose={confirmOverride}
        confirmText="Confirm"
        cancelText="Cancel"
      />
    </>
  )
}
